import React, { useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { gallaryImages } from "../assets/contents";
import ImageModal from "../components/ImageModal";

const GallaryPage = () => {
  const [open, setOpen] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);

  const handleOpen = (img) => {
    setSelectedImg(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImg(null);
  };

  return (
    <Box
      sx={{
        px: { xs: 4, md: 20 }, // horizontal padding
        py: { xs: 4, md: 4 }, // vertical padding
        bgcolor: "#fff",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontFamily: "Playfair Display, serif",
          color: "#b89b6c",
          fontWeight: 600,
          fontSize: { xs: "2rem", md: "2.8rem" },
          lineHeight: 1.3,
          textAlign: "center",
          textDecoration: "underline",
        }}
      >
        Gallary
      </Typography>
      <Grid
        item
        size={12}
        sx={{
          px: { xs: 1, sm:2, md: 2.5, lg: 5 },
          mt: 4,
          display: "flex",
          justifyContent: { xs: "center", md: "flex-start" },
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        {/* Horizontal IMAGEs */}
        {gallaryImages.gallaryHImgs.map((imge, index) => (
          <Box
            key={index}
            component="img"
            src={imge}
            alt="Gallary"
            onClick={() => handleOpen(imge)}
            sx={{
              maxWidth: { xs: "100px", sm: "180px", md: "210px" },
              cursor: "pointer",
              borderRadius: 1.5,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          />
        ))}
        {/* Vertical IMAGEs */}
        {gallaryImages.gallaryVImgs.map((imge, index) => (
          <Box
            key={index}
            component="img"
            src={imge}
            alt="Gallary"
            onClick={() => handleOpen(imge)}
            sx={{
              maxWidth: { xs: "100px", sm: "180px", md: "210px" },
              // maxWidth: { xs: "250px", sm: "350px", md: "500px" },
              cursor: "pointer",
              borderRadius: 1.5,
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          />
        ))}
      </Grid>
      <ImageModal open={open} image={selectedImg} onClose={handleClose} />
    </Box>
  );
};

export default GallaryPage;
